// Resolves library moderation settings from user data or guest defaults.

import { DEFAULT_VOLUMES } from '../../../hooks/useMediaVolumeManager';
import { defaultPoppyChatSettings } from '@airhead-games/shared/configs';
import type { ModSettings, UserAuthFields } from '@airhead-games/shared/types';

const GUEST_MOD_SETTINGS: ModSettings = {
  censorCommon: false,
  censorCustom: false,
  censorRigid: false,
  censorCustomWords: [],
  twitchTermsBlocked: false,
  censorTwitchWords: [],
  twitchPlayersOnly: false,
  disallowBlockedAndBanned: false,
  blockedTwitchUsers: [],
  poppyChat: { ...defaultPoppyChatSettings },
  audioLevels: DEFAULT_VOLUMES,
};

export const toLibraryModSettingsState = (
  user?: UserAuthFields | null
): ModSettings => {
  if (!user?.modSettings) {
    return GUEST_MOD_SETTINGS;
  }

  return {
    ...GUEST_MOD_SETTINGS,
    ...user.modSettings,
    twitchTermsBlocked: user.modSettings.twitchTermsBlocked ?? false,
    censorTwitchWords: user.modSettings.censorTwitchWords ?? [],
    disallowBlockedAndBanned:
      user.modSettings.disallowBlockedAndBanned ?? false,
    blockedTwitchUsers: user.modSettings.blockedTwitchUsers ?? [],
    poppyChat: {
      ...GUEST_MOD_SETTINGS.poppyChat,
      ...user.modSettings.poppyChat,
    },
  };
};
